import { View } from 'react-native'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import Gradient from '@ui/effects/Gradient'
import { colors } from '@ui/colors'
import Border from '@ui/effects/Border'

export default function TopbarPage() {
  return (
    <Page stage="vision">
      <View className="flex flex-col">
        <Header
          title="Header"
          desc="Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua."
        />
        <View className="flex flex-col gap-8 px-8 pb-16">
          {Array.from({ length: 10 }).map((_, index) => (
            <View
              key={index}
              className="flex"
              style={{ height: 320, borderRadius: 24 }}
            >
              <Gradient
                colors={[
                  colors.gray[75],
                  colors.gray[50],
                  colors.white25,
                  colors.white,
                ]}
                start={[0, 0]}
                end={[1, 1]}
                style={{ borderRadius: 25 }}
              />
              <Border style={{ borderRadius: 24 }} />
            </View>
          ))}
        </View>
      </View>
    </Page>
  )
}
